import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/esm/taggedTemplateLiteralLoose";

function _templateObject2() {
  var data = _taggedTemplateLiteralLoose(["\n  position: relative;\n  box-sizing: content-box;\n  ", "\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n  position: absolute;\n  ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React from 'react';
import styled from 'styled-components';
import { useTooltip } from './useTooltip';
import { zIndexValue as zIndexPosition } from '../helpers/position';
import { getPx } from '../helpers/common';
var OuterWrapper = styled.div(_templateObject(), function (_ref) {
  var $offset = _ref.$offset,
      $enterOffset = _ref.$enterOffset;
  return "\n    top: -" + getPx($offset + $enterOffset) + ";\n    bottom: -" + getPx($offset + $enterOffset) + ";\n    left: -" + getPx($offset + $enterOffset) + ";\n    right: -" + getPx($offset + $enterOffset) + ";\n  ";
});
var Wrapper = styled.div(_templateObject2(), function (_ref2) {
  var flex = _ref2.flex;
  return flex && "\n    display: inline-flex;\n    justify-content: center;\n    align-items: center;\n  ";
});
export var Tooltip = function Tooltip(_ref3) {
  var open = _ref3.open,
      _ref3$defaultOpen = _ref3.defaultOpen,
      defaultOpen = _ref3$defaultOpen === void 0 ? false : _ref3$defaultOpen,
      _ref3$inverse = _ref3.inverse,
      inverse = _ref3$inverse === void 0 ? false : _ref3$inverse,
      _ref3$blurred = _ref3.blurred,
      blurred = _ref3$blurred === void 0 ? false : _ref3$blurred,
      _ref3$withOverflowHid = _ref3.withOverflowHidden,
      withOverflowHidden = _ref3$withOverflowHid === void 0 ? false : _ref3$withOverflowHid,
      _ref3$animate = _ref3.animate,
      animate = _ref3$animate === void 0 ? true : _ref3$animate,
      parentQuerySelector = _ref3.parentQuerySelector,
      parentElement = _ref3.parentElement,
      _ref3$offset = _ref3.offset,
      offset = _ref3$offset === void 0 ? 8 : _ref3$offset,
      _ref3$enterOffset = _ref3.enterOffset,
      enterOffset = _ref3$enterOffset === void 0 ? 8 : _ref3$enterOffset,
      _ref3$multiline = _ref3.multiline,
      multiline = _ref3$multiline === void 0 ? false : _ref3$multiline,
      _ref3$trigger = _ref3.trigger,
      trigger = _ref3$trigger === void 0 ? 'hover' : _ref3$trigger,
      _ref3$position = _ref3.position,
      position = _ref3$position === void 0 ? 'top' : _ref3$position,
      onClick = _ref3.onClick,
      onOpen = _ref3.onOpen,
      onClose = _ref3.onClose,
      onToggle = _ref3.onToggle,
      onOpened = _ref3.onOpened,
      onClosed = _ref3.onClosed,
      onToggled = _ref3.onToggled,
      content = _ref3.content,
      renderContent = _ref3.renderContent,
      _ref3$zIndex = _ref3.zIndex,
      zIndex = _ref3$zIndex === void 0 ? zIndexPosition('tooltip') : _ref3$zIndex,
      _ref3$noPadding = _ref3.noPadding,
      noPadding = _ref3$noPadding === void 0 ? false : _ref3$noPadding,
      _ref3$withMargin = _ref3.withMargin,
      withMargin = _ref3$withMargin === void 0 ? false : _ref3$withMargin,
      wrapperStyle = _ref3.wrapperStyle,
      customWrapper = _ref3.customWrapper,
      width = _ref3.width,
      height = _ref3.height,
      disabled = _ref3.disabled,
      _ref3$size = _ref3.size,
      size = _ref3$size === void 0 ? 'small' : _ref3$size,
      _ref3$appearType = _ref3.appearType,
      appearType = _ref3$appearType === void 0 ? 'slide' : _ref3$appearType,
      _ref3$flex = _ref3.flex,
      flex = _ref3$flex === void 0 ? false : _ref3$flex,
      children = _ref3.children,
      _ref3$closeOnScroll = _ref3.closeOnScroll,
      closeOnScroll = _ref3$closeOnScroll === void 0 ? false : _ref3$closeOnScroll,
      _ref3$closeOnResize = _ref3.closeOnResize,
      closeOnResize = _ref3$closeOnResize === void 0 ? false : _ref3$closeOnResize,
      _ref3$closeOnOutsideC = _ref3.closeOnOutsideClick,
      closeOnOutsideClick = _ref3$closeOnOutsideC === void 0 ? true : _ref3$closeOnOutsideC,
      _ref3$noFlip = _ref3.noFlip,
      noFlip = _ref3$noFlip === void 0 ? true : _ref3$noFlip,
      closeDelay = _ref3.closeDelay,
      excludeRef = _ref3.excludeRef,
      props = _objectWithoutPropertiesLoose(_ref3, ["open", "defaultOpen", "inverse", "blurred", "withOverflowHidden", "animate", "parentQuerySelector", "parentElement", "offset", "enterOffset", "multiline", "trigger", "position", "onClick", "onOpen", "onClose", "onToggle", "onOpened", "onClosed", "onToggled", "content", "renderContent", "zIndex", "noPadding", "withMargin", "wrapperStyle", "customWrapper", "width", "height", "disabled", "size", "appearType", "flex", "children", "closeOnScroll", "closeOnResize", "closeOnOutsideClick", "noFlip", "closeDelay", "excludeRef"]);

  var _useTooltip = useTooltip({
    open: open,
    defaultOpen: defaultOpen,
    withOverflowHidden: withOverflowHidden,
    animate: animate,
    parentQuerySelector: parentQuerySelector,
    parentElement: parentElement,
    offset: offset,
    multiline: multiline,
    trigger: trigger,
    position: position,
    onClick: onClick,
    onOpen: onOpen,
    onClose: onClose,
    onToggle: onToggle,
    onOpened: onOpened,
    onClosed: onClosed,
    onToggled: onToggled,
    content: content,
    renderContent: renderContent,
    zIndex: zIndex,
    noPadding: noPadding,
    withMargin: withMargin,
    wrapperStyle: wrapperStyle,
    customWrapper: customWrapper,
    width: width,
    height: height,
    disabled: disabled,
    size: size,
    closeOnScroll: closeOnScroll,
    closeOnResize: closeOnResize,
    closeOnOutsideClick: closeOnOutsideClick,
    appearType: appearType,
    inverse: inverse,
    blurred: blurred,
    noFlip: noFlip,
    excludeRef: excludeRef,
    closeDelay: closeDelay
  }),
      setRef = _useTooltip.setRef,
      portalNode = _useTooltip.portalNode,
      tooltipTrigger = _useTooltip.trigger;

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Wrapper, _extends({
    ref: setRef,
    flex: flex
  }, props), tooltipTrigger === 'enter' && /*#__PURE__*/React.createElement(OuterWrapper, {
    $offset: offset,
    $enterOffset: enterOffset
  }), children), portalNode);
};